import * as React from "react"
import type { SVGProps } from "react"
const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4 20.71q-.82 0-1.41-.58A2 2 0 0 1 2 18.7V6.54q.07-.72.59-1.24A2 2 0 0 1 4 4.71h16q.83 0 1.41.6.53.51.58 1.23H22v12.17q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm15.26-14H4.75L12 11.04zM4 8.6l6.98 4.18a2 2 0 0 0 1.02.27 2 2 0 0 0 1.02-.27L20 8.59v10.13H4z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgEmail
